import { useParams } from '@tanstack/react-router'
import { ReactNode } from 'react'

import { Tabs, TabsList, TabsTriggerAsLink } from '@/components/tabs'

interface Props {
    active: 'details' | 'instruments' | 'connections' | 'orders'
    isTemplate?: boolean
    children?: ReactNode
}
export default function MarketNavigation({ active, children, isTemplate }: Props) {
    const params = useParams({ strict: false }) as any

    return (
        <div className="relative">
            <Tabs>
                <TabsList>
                    <TabsTriggerAsLink
                        to="/$client_code/markets/$market_code"
                        params={params}
                        active={active === 'details'}
                    >
                        Details
                    </TabsTriggerAsLink>
                    <TabsTriggerAsLink
                        to="/$client_code/markets/$market_code/instruments"
                        params={params}
                        active={active === 'instruments'}
                    >
                        Instruments
                    </TabsTriggerAsLink>
                    {!isTemplate && (
                        <TabsTriggerAsLink
                            to="/$client_code/markets/$market_code/connections"
                            params={params}
                            active={active === 'connections'}
                        >
                            Connections
                        </TabsTriggerAsLink>
                    )}
                    <TabsTriggerAsLink
                        to="/$client_code/markets/$market_code/orders"
                        params={params}
                        active={active === 'orders'}
                    >
                        Orders
                    </TabsTriggerAsLink>
                </TabsList>
            </Tabs>
            {children && <div className="right-0 absolute-center-y">{children}</div>}
        </div>
    )
}
